import {
  ISipClientLinkedDeviceCreateProps,
  ISipClientLinkedDeviceProps,
  ISipClientLinkedDeviceSimpleProps,
  ISipClientLinkedDeviceUpdateParams,
} from './types';
import { api } from '../DefaultService';

export const ENDPOINT_SIP_CLIENT_LINKED_DEVICE = 'v1/sipClientLinkedDevice';

export const createSipClientLinkedDeviceAsync = async (
  data: ISipClientLinkedDeviceCreateProps,
): Promise<ISipClientLinkedDeviceProps> => {
  return await api
    .post(ENDPOINT_SIP_CLIENT_LINKED_DEVICE, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getSipClientLinkedDeviceByIdAsync = async (
  id: number,
): Promise<ISipClientLinkedDeviceProps> => {
  return await api
    .get(`${ENDPOINT_SIP_CLIENT_LINKED_DEVICE}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllSipClientLinkedDeviceByLicenseAsync = async (): Promise<
  ISipClientLinkedDeviceSimpleProps[]
> => {
  return await api
    .get(`${ENDPOINT_SIP_CLIENT_LINKED_DEVICE}/getAllByLicense`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllSipClientLinkedDeviceByLicenseCountAsync =
  async (): Promise<number> => {
    return await api
      .get(`${ENDPOINT_SIP_CLIENT_LINKED_DEVICE}/getAllByLicense/count`, {})
      .then((response) => response.data)
      .catch((error) => {
        throw new Error(
          error?.response?.data?.message || 'Erro interno do servidor!',
        );
      });
  };

export const updateSipClientLinkedDeviceAsync = async ({
  id,
  data,
}: ISipClientLinkedDeviceUpdateParams): Promise<ISipClientLinkedDeviceProps> => {
  return await api
    .put(`${ENDPOINT_SIP_CLIENT_LINKED_DEVICE}/${id}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const deleteSipClientLinkedDeviceAsync = async (
  id: number,
): Promise<void> => {
  await api
    .delete(`${ENDPOINT_SIP_CLIENT_LINKED_DEVICE}/${id}`)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};
